// ============================================================================
// EXPENSE TYPE ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const EXPENSE_TYPE_BASE_PATH = '/ExpenseType';

export const expenseTypeEndpoints = {
  list: () => buildEndpoint(EXPENSE_TYPE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${EXPENSE_TYPE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${EXPENSE_TYPE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(EXPENSE_TYPE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${EXPENSE_TYPE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${EXPENSE_TYPE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${EXPENSE_TYPE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default expenseTypeEndpoints;
